module.exports = __webpack_public_path__ + "static/media/05.d10265b9.mp3";